document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".privacy-tab-button");
  const tabSections = document.querySelectorAll(".privacy-section");
  const privacyTitle = document.querySelector(".privacy-title");

  function activateTab(tabSlug) {
    // Remove active classes from all buttons and sections
    tabButtons.forEach(btn => btn.classList.remove("active"));
    tabSections.forEach(sec => sec.classList.remove("active"));

    // Find the button and section for this tab
    const button = Array.from(tabButtons).find(
      btn => btn.dataset.tab.toLowerCase() === tabSlug.toLowerCase()
    );
    const section = document.getElementById(`tab-${tabSlug}`);

    if (button && section) {
      button.classList.add("active");
      section.classList.add("active");

      // Update privacy title (exclude SVG)
      const textNode = Array.from(button.childNodes).find(
        node => node.nodeType === Node.TEXT_NODE
      );
      if (privacyTitle && textNode) {
        privacyTitle.textContent = textNode.textContent.trim();
      }
    }
  }

  // Get query string after "?" and use it as initial tab
  const query = window.location.search.substring(1); // removes "?"
  const initialTab = query || (tabButtons[0]?.dataset.tab || "");

  if (initialTab) activateTab(initialTab);

  // Add click events to tabs
  tabButtons.forEach(button => {
    button.addEventListener("click", () => {
      const tabSlug = button.dataset.tab;
      activateTab(tabSlug);

      // Update URL query string without reloading
      history.replaceState(null, null, `${window.location.pathname}?${tabSlug}`);
    });
  });
});
